import * as React from "react";
import {AppState} from "../components/app/app-mobx";
import {MapViewerConfiguration} from "../config/map-viewer-configuration";
import {NavigationConfiguration} from "../config/navigation-configuration";
import {Item, Image} from "semantic-ui-react";
import {Auftragsverwaltung} from "../stores/auftragsverwaltung-mobx";

export interface UeberProps {
    appStore: AppState;
    auftragsverwaltung: Auftragsverwaltung;
    mapViewerConfig: MapViewerConfiguration;
}

export class Ueber extends React.Component<UeberProps, any> {
    constructor(props: UeberProps) {
        super(props);
    }
    componentDidMount(): void {
        const {appStore, auftragsverwaltung} = this.props;
        const breadcrumbs = new NavigationConfiguration();
        breadcrumbs.items = [
            { title: "Über die Auftragsverwaltung" }
        ];
        appStore.setBreadcrumbs(breadcrumbs);
        appStore.setPageTitle("Was ist die Auftragsverwaltung?");
        appStore.setShowAside(true);
        appStore.setAsideContent(null);
        auftragsverwaltung.setShowMap(false);
    }
    render(): React.ReactElement | null {
        return(
            <div className={"richtext"}>
                <Item.Group>
                    <Item>
                        <Item.Content>
                            <p>Das Objektwesen besteht aus den Prozessen der öffentlichen Verwaltung (inklusive
                                Ereignisse und Meldungen) der folgenden fünf Domänen:</p>
                            <ul>
                                <li>Bau: Lebenszyklus von Bauten</li>
                                <li>Amtliche Vermessung (AV): Lage und Geometrie der Objekte</li>
                                <li>Versicherung: Gebäudebewertung zur Risikoabschätzung und Schadensprävention</li>
                                <li>Steuern: Schätzung Grundstück und Gebäude für Steuern und Versicherungen</li>
                                <li>Grundbuch (GB): Eigentümer, Dienstbarkeiten (Rechte und Lasten)</li>
                            </ul>
                            <p>Der Kanton Luzern hat zusätzlich die Bereiche Statistik und Geoinformation in das
                                Objektwesen integriert.</p>
                        </Item.Content>
                    </Item>
                    <Item><Item.Content>
                        <Image className={"objektlu"} src={"./images/objektlu.svg"} centered />
                    </Item.Content></Item>
                    <Item>
                        <Item.Content>
                            <Item.Header as={"h3"}>Was sind die Ziele des objekt.lu Objektwesen Luzern?</Item.Header>
                            <p>Objekt.lu Objektwesen Luzern ist ein kantonales E-Government-Projekt und basiert auf
                                dem Schweizer E-Government
                                Datenstandard <a href={"https://www.ech.ch/index.php/de/standards/53634"}
                                target={"_blank"} rel={"noreferrer"}>
                                <span className={"linked"}>eCH-0129 Objektwesen</span></a></p>
                            <p>Mit dem Projekt soll eine gesamtheitliche Lösung für das Objektwesen im Kanton Luzern
                                (Kanton und Gemeinden) realisiert werden.<br />
                                Im Fokus stehen dabei die übergeordneten Zielsetzungen:
                            </p>
                            <ul>
                                <li>Der Umgang mit den Objektdaten wird vereinfacht</li>
                                <li>Die Redundanzen von Daten wird vermieden</li>
                                <li>Die Zuverlässigkeit der Objektdaten wird verbessert</li>
                            </ul>
                        </Item.Content>
                    </Item>
                    <Item>
                        <Item.Content>
                            <Item.Header as={"h3"}>Benutzeranleitung</Item.Header>
                            <p>
                                <a href={"./files/03_objekt.lu_Benutzeranleitung_Informationssystem_210624.pdf"}
                                    className={"pdf"} target={"_blank"} rel="noreferrer">
                                    <span className={"linked"}>Benutzeranleitung Informationssystem</span></a>
                            </p>
                        </Item.Content>
                    </Item>
                </Item.Group>
            </div>
        );
    }
}
